export default __webpack_public_path__ + "media/images/icons/id-card-regular-da6420fdd784b73ef4fba8b7c81d4112.svg";